export default "__VITE_ASSET__BvoOGi76__"